import { render, staticRenderFns } from "./PortfolioCardWithDonutChartSkeleton.vue?vue&type=template&id=577526ee&scoped=true"
import script from "./PortfolioCardWithDonutChartSkeleton.vue?vue&type=script&lang=js"
export * from "./PortfolioCardWithDonutChartSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PortfolioCardWithDonutChartSkeleton.vue?vue&type=style&index=0&id=577526ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577526ee",
  null
  
)

export default component.exports